import { useRef, useState } from "react";
import ReactS3Uploader from "react-s3-uploader";

const FileUploader = ({
  outsideRef,
  multiple = false,
  createUploadUrl,
  onStart = (f: File, cb: () => void) => {
    cb();
  },
  onError = () => {},
  onProgress = () => {},
  onUploadFinish,
  accept = "image/*,video/*",
}: {
  accept?: string;
  createUploadUrl: (
    file: File,
    callback: ({ signedUrl }: { signedUrl: string }) => void
  ) => void;
  onUploadFinish: ({
    temporaryFileUrl,
    fileKey,
    file,
  }: {
    temporaryFileUrl: string;
    fileKey: string;
    file: File
  }) => void;
  multiple?: boolean;
  onError?: (error: any) => void;
  onProgress?: (progress: number) => void;
  onStart?: (f: File, cb: () => void) => void;
  outsideRef?: React.RefObject<HTMLInputElement>;
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const refToUse = outsideRef ? outsideRef : inputRef;

  return (
    <>
      <ReactS3Uploader
        style={{ display: "none" }}
        //@ts-ignore
        inputRef={refToUse}
        getSignedUrl={(file, callback) => createUploadUrl(file, callback)}
        accept={accept}
        multiple={multiple}
        uploadRequestHeaders={(file) => ({
          "Content-Type": file.type,
          "x-amz-acl": "private"
        })}
        onError={(e) => {
          if (refToUse.current) {
            refToUse.current.value = "";
          }

          onError(e);
        }}
        preprocess={(f, next) => {
          onStart(f, () => next(f));
        }}
        onProgress={onProgress}
        onFinish={async (result, file) => {
          const temporaryFileUrl = URL.createObjectURL(file);
          onUploadFinish({
            temporaryFileUrl,
            fileKey: result.fileKey,
            file,
          });

          //@ts-ignore
          if (refToUse.current) {
            refToUse.current.value = "";
          }
        }}
        contentDisposition="auto"
      />
    </>
  );
};

export default FileUploader;
